import { createFileRoute, redirect } from "@tanstack/react-router";
// "roof-maintenance" on the old WP site maps to the "maintenance" category here.
export const Route = createFileRoute("/category/roof-maintenance")({
  beforeLoad: () => { throw redirect({ to: "/blog/category/$category", params: { category: "maintenance" }, statusCode: 301 }); },
});
